<template>
  <section id="landing-faq">
    <div class="flex">
      <div class="img"></div>
      <div class="column">
        <header>
          <h3>Często zadawane pytania i odpowiedzi</h3>
          <h5>Zapewniamy szeroką ofertę usług dla firm,<br> fachową i miłą obsługę oraz miejsce do spotkań,<br> gdzie możesz poczuć się nie tylko jak w pracy,<br> ale również jak u siebie.</h5>
        </header>
        <div class="flex2">
          <router-link to="/faq" class="default" title="Przejdź do Faq">Sprawdź</router-link>
          <h6>FAQ</h6>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LandingFaq',
}
</script>

<style scoped lang="scss">
  section#landing-faq { display: flex; justify-content: center; }
  div.flex { display: flex; align-items: center;}
  div.flex2 { display: flex; justify-content: space-between; align-items: flex-start; width: 700px; }
  div.img { width: 372px; height: 586px; margin: 0 60px 0 0; background: url('../assets/faq.webp') no-repeat 50% 50%; flex-shrink: 0; }
  div.column { margin: 0 0 0 60px; }
  header { margin-top: 80px; width: 600px; }
  header h3 { margin: 0 0 30px 0; padding: 0; color: #000; font-size: 50px; font-weight: 500; text-align: left; }
  header h5  { margin: 30px 0; padding: 0; color: #000; font-weight: 400; font-size: 18px; }
  h6 { margin: -25px 0 0 0; padding: 0; font-size: 80px; color: $grayLight; align-self: center; font-weight: 700; flex-shrink: 0; flex-grow: 0; }
  a { flex-shrink: 0; flex-grow: 0; }

  @media (max-width: 1250px) {
    div.img { display: none; }
  }

  @media (max-width: 1100px) {
    header h3 { font-size: 26px; }
    header h5  { font-size: 16px; }
  }

  @media (max-width: 850px) {
    section#landing-faq { margin-bottom: 20px; }
    header { margin-top: 20px; width: calc(100vw - 40px); }
    div.flex2 { width: 100%; }
    div.column { margin: 0; }
    header h3 { text-align: center; }
    header h5  { text-align: center; }
    a { margin: 0 auto; }
    h6 { display: none; }
  }

  @media (max-width: 700px) {
    header h3 { margin: 0 0 30px 0; font-size: 22px; }
    header h5  { margin: 30px 0; font-size: 14px; }
  }
</style>
